import createRoute   from '@widesk-ui/tools/createRoute';
import TaxonomyModel from '@models/website/TaxonomyModel';

const route = createRoute.splitView(
	'/configuration/taxonomies',
	'website',
	'TaxonomySplitView',
	`${TaxonomyModel.localize('plural')} générales`,
);
export default route;
